import ContentLoader from "react-content-loader";
import React from "react";

export const DesktopCareTeamLoader = (props) => (
  <div className={props.classes}>
    <ContentLoader
      height={25}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      speed={2}
      width={400}
    >
      <rect height="18" rx="11" ry="11" width="90" x="4" y="5" />
      <rect height="18" rx="11" ry="11" width="90" x="120" y="5" />
    </ContentLoader>
  </div>
);

export const MobileCareTeamLoader = (props) => (
  <div className={props.classes}>
    <ContentLoader
      height={40}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      speed={2}
      width={250}
    >
      <rect height="30" rx="15" ry="15" width="150" x="5" y="5" />
    </ContentLoader>
  </div>
);
